import {
    Divider,
    Grid,
    Container,
    TextField,
    Dialog,
    DialogTitle,
    Card,
    CardContent,
    IconButton,
} from '@mui/material'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { Close } from '@mui/icons-material'
import { ActionButton } from '../../../utils/ui_utils'

function TablesGroupDrawer({
    initialValues,
    title,
    visible,
    okText,
    onSubmit,
    onClose,
    outlet
}) {

    if (initialValues == undefined) {
        initialValues = {
            name: '',
        }
    }

    if (outlet === undefined || outlet === null) {
        outlet = ""
    }

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Required').min(2, 'Min length is 2 character'),
    })

    const handleSubmit = (values, { resetForm, setErrors, setStatus, setSubmitting }) => {
        onSubmit(values)
    }

    return (
        <Dialog
            maxWidth='xs'
            fullWidth
            open={visible}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle sx={{ "display": "flex", "justifyContent": "space-between", alignItems: "center" }}>
                {title}
                <IconButton
                    component="span"
                    size='small'
                    sx={{ ':hover': { backgroundColor: "red", color: "white" } }}
                    onClick={onClose}
                    variant="contained"
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <Container sx={{ marginBottom: 5 }} >
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({
                        errors,
                        handleBlur,
                        handleChange,
                        handleSubmit,
                        isSubmitting,
                        touched,
                        values,
                        status,
                    }) => (

                        <form onSubmit={handleSubmit}>
                            <Divider my={2} />
                            <Card>
                                <CardContent>
                                    <Grid container spacing={2} >
                                        <Grid item md={6}>
                                            <TextField
                                                size="small"
                                                name="name"
                                                label="Name"
                                                value={values.name}
                                                error={Boolean(touched.name && errors.name)}
                                                helperText={touched.name && errors.name}
                                                fullWidth
                                                onBlur={handleBlur}
                                                margin="dense"
                                                onChange={handleChange}
                                                variant="outlined"
                                                autoFocus
                                            />
                                        </Grid>
                                        <Grid item md={6}>
                                            <TextField
                                                size="small"
                                                name="outlet"
                                                id="outlet"
                                                label="Outlet"
                                                value={outlet}
                                                error={Boolean(touched.outlet && errors.outlet)}
                                                fullWidth
                                                onBlur={handleBlur}
                                                margin="dense"
                                                disabled
                                                variant="outlined" />
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                            <Grid container justifyContent="flex-end">
                                <Grid item>
                                    <ActionButton variant="outlined" size='medium' type="submit" mt={8}>
                                        {okText}
                                    </ActionButton>
                                </Grid>
                            </Grid>
                        </form>
                    )}
                </Formik>
            </Container>
        </Dialog>
    );
}

export default TablesGroupDrawer;